import { Routes } from '@angular/router';

export const reportRoutes: Routes = [
  {
    path: '404-report',
    loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule)
  },
  {
    path: 'url-hits-report',
    loadChildren: () => import('./url-hits/url-hits.module').then((m) => m.UrlHitsModule)
  },
  {
    path: 'inventory-report',
    loadComponent: () =>
      import('./inventory-report/pages/inventory-report-page/inventory-report-page.component').then(
        (m) => m.InventoryReportPageComponent
      )
  },
  {
    path: 'user-activity-report',
    loadComponent: () =>
      import('./user-activity-report/pages/user-activity-report-page/user-activity-report-page.component').then(
        (m) => m.UserActivityReportPageComponent
      )
  },
  {
    path: 'historical-data-export',
    loadComponent: () =>
      import('./historical-data-report/pages/historical-data-report-page/historical-data-report-page.component').then(
        (m) => m.HistoricalDataReportPageComponent
      )
  },
  {
    path: 'related-pages-report',
    loadComponent: () =>
      import('./related-pages-report/pages/related-pages-report-page/related-pages-report-page.component').then(
        (m) => m.RelatedPagesReportPageComponent
      )
  },
  {
    path: 'collections-report',
    loadComponent: () =>
      import('./collections-report/pages/collections-report-page/collections-report-page.component').then(
        (m) => m.CollectionsReportPageComponent
      )
  }
];
